import {LadingCustomerStatus} from "@/enums/status/ladingcustomerstatus";
import {LadingStatus} from "@/enums/status/lading";

const mapper = {} as any;
mapper[LadingCustomerStatus.ChoLayHang] = [LadingStatus.ChoLayHang, LadingStatus.ChoCapNhat];
mapper[LadingCustomerStatus.LayHangThanhCong] = [
    LadingStatus.GdKhoiTao,
    LadingStatus.NhapKhoGiaoHang,
    LadingStatus.NhapKhoChuyenVung,
    LadingStatus.DangChuyenVung,
    LadingStatus.LayHangThanhCong,
    LadingStatus.LayHangThanhCongChoCapNhat,
    LadingStatus.NhapKhoChoCapNhat,
];
mapper[LadingCustomerStatus.DiPhat] = [
    LadingStatus.DiPhat,
    LadingStatus.PhanCongPhat,
    LadingStatus.ChuyenTiep,
    LadingStatus.DuyetChuyenTiep
];
mapper[LadingCustomerStatus.PhatThanhCong] = [LadingStatus.PhatThanhCong];
mapper[LadingCustomerStatus.PhatKhongThanhCong] = [LadingStatus.DonSuCo, LadingStatus.PhatLai];
mapper[LadingCustomerStatus.DuyetHoan] = [LadingStatus.DuyetHoan];
mapper[LadingCustomerStatus.DangHoan] = [
    LadingStatus.DangHoan,
    LadingStatus.NhapKhoChuyenHoan,
    LadingStatus.DiHoan,
    LadingStatus.PhanCongHoan
];
mapper[LadingCustomerStatus.HoanThanhCong] = [LadingStatus.HoanThanhCong];
mapper[LadingCustomerStatus.Reject] = [LadingStatus.Reject];
export default mapper